import React from 'react';
import { Form, Input, Button,Spin,Select,Modal,Card,Space,Dropdown,Menu, Pagination, Tabs } from 'antd';
import axios from 'axios'
import * as serverconfig from '../../serverconn'
import { UserOutlined, LockOutlined, LoadingOutlined, MailOutlined,UploadOutlined,PrinterOutlined,SearchOutlined,SortAscendingOutlined,SortDescendingOutlined,DownOutlined } from '@ant-design/icons';
import * as reactstrp from 'reactstrap';
import BarCodeView from '../containers/BarCodeView'

import ReactToPrint from 'react-to-print';
import Barcode from 'react-barcode';
import {
  Col,
  Row,
} from 'reactstrap';


var CryptoJS = require("crypto-js");

const FormItem=Form.Item;
const antIcon = <LoadingOutlined style={{ fontSize: 60 }} spin />;
const { Option } = Select;
const { Search } = Input;

var token= ''
var bizuserid=''

// Print component for single entry barcodes
class SingleEntryPrintComponent extends React.Component {
  render() {
    // If sample_barcodes is already filtered, use it directly; otherwise filter it
    const singleEntryBarcodes = Array.isArray(this.props.sample_barcodes) && this.props.sample_barcodes.length > 0 && this.props.sample_barcodes[0].bar_code_type === 'single_entry'
      ? this.props.sample_barcodes
      : this.props.sample_barcodes.filter(item => item.bar_code_type === 'single_entry');
    
    console.log('SingleEntryPrintComponent - Debug:', {
      sample_barcodes: this.props.sample_barcodes,
      singleEntryBarcodes: singleEntryBarcodes
    });
    
    if (!singleEntryBarcodes || singleEntryBarcodes.length === 0) {
      return (
        <div style={{
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          alignItems: 'center',
          padding: '50px',
          width: '100%',
          minHeight: '400px'
        }}>
          <div style={{
            fontSize: '24px',
            color: '#ff4d4f',
            marginBottom: '20px'
          }}>
            ⚠️ No Single Entry Barcodes Available
          </div>
          <div style={{
            fontSize: '16px',
            color: '#666',
            textAlign: 'center'
          }}>
            No single entry barcodes found to print.<br/>
            Please generate some single entry barcodes first.
          </div>
        </div>
      );
    }
    
    return (
      <div style={{
        display: 'flex',
        flexWrap: 'wrap',
        justifyContent: 'center',
        alignItems: 'center',
        padding: '10px',
        width: '100%'
      }}>
        <div style={{
          width: '100%',
          textAlign: 'center',
          marginBottom: '20px',
          fontSize: '18px',
          fontWeight: 'bold',
          color: '#1890ff'
        }}>
          Single Entry Barcodes - Printing {singleEntryBarcodes.length} codes
        </div>
        {singleEntryBarcodes.map((item, index) => (
          // Duplicate each barcode 3 times
          [1, 2, 3].map((duplicate) => (
            <div key={`${index}-${duplicate}`} style={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              margin: '10px',
              padding: '5px',
              border: 'none',
              background: 'none',
              minWidth: '160px'
            }}>
              <Barcode value={item.bar_code} width={1.5} height={40} displayValue={true}/>
              <div style={{ fontSize: '10px', marginTop: '5px', color: '#666' }}>
                {item.bar_code ? item.bar_code.substring(0, 8) + '...' : 'No Code'}
              </div>
            </div>
          ))
        )).flat()}
      </div>
    );
  }
}

// Print component for batch entry barcodes
class BatchEntryPrintComponent extends React.Component {
  render() {
    // If sample_barcodes is already filtered, use it directly; otherwise filter it
    const batchEntryBarcodes = Array.isArray(this.props.sample_barcodes) && this.props.sample_barcodes.length > 0 && this.props.sample_barcodes[0].bar_code_type === 'batch_entry'
      ? this.props.sample_barcodes
      : this.props.sample_barcodes.filter(item => item.bar_code_type === 'batch_entry');
    
    console.log('BatchEntryPrintComponent - Debug:', {
      sample_barcodes: this.props.sample_barcodes,
      batchEntryBarcodes: batchEntryBarcodes
    });
    
    if (!batchEntryBarcodes || batchEntryBarcodes.length === 0) {
      return (
        <div style={{
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          alignItems: 'center',
          padding: '50px',
          width: '100%',
          minHeight: '400px'
        }}>
          <div style={{
            fontSize: '24px',
            color: '#ff4d4f',
            marginBottom: '20px'
          }}>
            ⚠️ No Batch Entry Barcodes Available
          </div>
          <div style={{
            fontSize: '16px',
            color: '#666',
            textAlign: 'center'
          }}>
            No batch entry barcodes found to print.<br/>
            Please generate some batch entry barcodes first.
          </div>
        </div>
      );
    }
    
    return (
      <div style={{
        display: 'flex',
        flexWrap: 'wrap',
        justifyContent: 'center',
        alignItems: 'center',
        padding: '10px',
        width: '100%'
      }}>
        <div style={{
          width: '100%',
          textAlign: 'center',
          marginBottom: '20px',
          fontSize: '18px',
          fontWeight: 'bold',
          color: '#1890ff'
        }}>
          Batch Entry Barcodes - Printing {batchEntryBarcodes.length} codes
        </div>
        {batchEntryBarcodes.map((item, index) => (
          // Duplicate each barcode 3 times
          [1, 2, 3].map((duplicate) => (
            <div key={`${index}-${duplicate}`} style={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              margin: '10px',
              padding: '5px',
              border: 'none',
              background: 'none',
              minWidth: '160px'
            }}>
              <Barcode value={item.bar_code} width={1.5} height={40} displayValue={true}/>
              <div style={{ fontSize: '10px', marginTop: '5px', color: '#666' }}>
                {item.bar_code ? item.bar_code.substring(0, 8) + '...' : 'No Code'}
              </div>
            </div>
          ))
        )).flat()}
      </div>
    );
  }
}

// Print component for single barcode
class SinglePrintComponent extends React.Component {
  render() {
    return (
      <div style={{
        display: 'flex',
        flexWrap: 'wrap',
        justifyContent: 'center',
        alignItems: 'center',
        padding: '10px',
        width: '100%'
      }}>
        {/* Duplicate the single barcode 3 times */}
        {[1, 2, 3].map((duplicate) => (
          <div key={duplicate} style={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            margin: '10px',
            padding: '5px',
            border: 'none',
            background: 'none',
            minWidth: '160px'
          }}>
            <Barcode value={this.props.barcode_value} width={2} height={60} displayValue={true}/>
          </div>
        ))}
      </div>
    );
  }
}

// Print component for quantity-based printing
class QuantityPrintComponent extends React.Component {
  render() {
    const { barcodes, quantity, type } = this.props;
    const codesToPrint = barcodes.slice(0, quantity);
    
    console.log('QuantityPrintComponent - Debug:', {
      barcodes: barcodes,
      quantity: quantity,
      type: type,
      codesToPrint: codesToPrint
    });
    
    if (!barcodes || barcodes.length === 0) {
      return (
        <div style={{
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          alignItems: 'center',
          padding: '50px',
          width: '100%',
          minHeight: '400px'
        }}>
          <div style={{
            fontSize: '24px',
            color: '#ff4d4f',
            marginBottom: '20px'
          }}>
            ⚠️ No Barcodes Available
          </div>
          <div style={{
            fontSize: '16px',
            color: '#666',
            textAlign: 'center'
          }}>
            No {type} barcodes found to print.<br/>
            Please generate some barcodes first.
          </div>
        </div>
      );
    }
    
    return (
      <div style={{
        display: 'flex',
        flexWrap: 'wrap',
        justifyContent: 'center',
        alignItems: 'center',
        padding: '10px',
        width: '100%'
      }}>
        <div style={{
          width: '100%',
          textAlign: 'center',
          marginBottom: '20px',
          fontSize: '18px',
          fontWeight: 'bold',
          color: '#1890ff'
        }}>
          {type.charAt(0).toUpperCase() + type.slice(1)} Barcodes - Printing {Math.min(quantity, codesToPrint.length)} codes
        </div>
        {codesToPrint.map((item, index) => (
          // Duplicate each barcode 3 times
          [1, 2, 3].map((duplicate) => (
            <div key={`${index}-${duplicate}`} style={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              margin: '10px',
              padding: '5px',
              border: 'none',
              background: 'none',
              minWidth: '160px'
            }}>
              <Barcode value={item.bar_code} width={1.5} height={40} displayValue={true}/>
              <div style={{ fontSize: '10px', marginTop: '5px', color: '#666' }}>
                {item.bar_code ? item.bar_code.substring(0, 8) + '...' : 'No Code'}
              </div>
            </div>
          ))
        )).flat()}
      </div>
    );
  }
}

// Print component for dynamically fetched barcodes
class DynamicPrintComponent extends React.Component {
  state = {
    barcodes: [],
    loading: true,
    error: null
  }

  componentDidMount() {
    this.loadBarcodes();
  }

  loadBarcodes = async () => {
    try {
      this.setState({ loading: true, error: null });
      
      const { type, quantity, fetchFunction } = this.props;
      const barcodes = await fetchFunction(type, quantity);
      
      console.log('DynamicPrintComponent - Loaded barcodes:', barcodes);
      
      this.setState({ 
        barcodes: barcodes, 
        loading: false 
      });
      
    } catch (error) {
      console.error('DynamicPrintComponent - Error loading barcodes:', error);
      this.setState({ 
        error: error.message, 
        loading: false 
      });
    }
  }

  render() {
    const { barcodes, loading, error } = this.state;
    const { quantity, type } = this.props;
    const codesToPrint = barcodes.slice(0, quantity);
    
    if (loading) {
      return (
        <div style={{
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          alignItems: 'center',
          padding: '50px',
          width: '100%',
          minHeight: '400px'
        }}>
          <div style={{ fontSize: '18px', color: '#1890ff', marginBottom: '20px' }}>
            Loading {type} barcodes for printing...
          </div>
          <Spin size="large" />
        </div>
      );
    }
    
    if (error) {
      return (
        <div style={{
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          alignItems: 'center',
          padding: '50px',
          width: '100%',
          minHeight: '400px'
        }}>
          <div style={{
            fontSize: '24px',
            color: '#ff4d4f',
            marginBottom: '20px'
          }}>
            ❌ Error Loading Barcodes
          </div>
          <div style={{
            fontSize: '16px',
            color: '#666',
            textAlign: 'center'
          }}>
            {error}
          </div>
        </div>
      );
    }
    
    if (!barcodes || barcodes.length === 0) {
      return (
        <div style={{
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          alignItems: 'center',
          padding: '50px',
          width: '100%',
          minHeight: '400px'
        }}>
          <div style={{
            fontSize: '24px',
            color: '#ff4d4f',
            marginBottom: '20px'
          }}>
            ⚠️ No Barcodes Available
          </div>
          <div style={{
            fontSize: '16px',
            color: '#666',
            textAlign: 'center'
          }}>
            No {type} barcodes found to print.<br/>
            Please generate some barcodes first.
          </div>
        </div>
      );
    }
    
    return (
      <div style={{
        display: 'flex',
        flexWrap: 'wrap',
        justifyContent: 'center',
        alignItems: 'center',
        padding: '10px',
        width: '100%'
      }}>
        <div style={{
          width: '100%',
          textAlign: 'center',
          marginBottom: '20px',
          fontSize: '18px',
          fontWeight: 'bold',
          color: '#1890ff'
        }}>
          {type.charAt(0).toUpperCase() + type.slice(1)} Barcodes - Printing {Math.min(quantity, codesToPrint.length)} codes
        </div>
        {codesToPrint.map((item, index) => (
          // Duplicate each barcode 3 times
          [1, 2, 3].map((duplicate) => (
            <div key={`${index}-${duplicate}`} style={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              margin: '10px',
              padding: '5px',
              border: 'none',
              background: 'none',
              minWidth: '160px'
            }}>
              <Barcode value={item.bar_code} width={1.5} height={40} displayValue={true}/>
              <div style={{ fontSize: '10px', marginTop: '5px', color: '#666' }}>
                {item.bar_code ? item.bar_code.substring(0, 8) + '...' : 'No Code'}
              </div>
            </div>
          ))
        )).flat()}
      </div>
    );
  }
}

// Print component for package codes
class PackagePrintComponent extends React.Component {
  render() {
    // If sample_barcodes is already filtered, use it directly; otherwise filter it
    const packageBarcodes = Array.isArray(this.props.sample_barcodes) && this.props.sample_barcodes.length > 0 && this.props.sample_barcodes[0].bar_code_type === 'package'
      ? this.props.sample_barcodes
      : this.props.sample_barcodes.filter(item => item.bar_code_type === 'package');
    
    console.log('PackagePrintComponent - Debug:', {
      sample_barcodes: this.props.sample_barcodes,
      packageBarcodes: packageBarcodes
    });
    
    if (!packageBarcodes || packageBarcodes.length === 0) {
      return (
        <div style={{
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          alignItems: 'center',
          padding: '50px',
          width: '100%',
          minHeight: '400px'
        }}>
          <div style={{
            fontSize: '24px',
            color: '#ff4d4f',
            marginBottom: '20px'
          }}>
            ⚠️ No Package Barcodes Available
          </div>
          <div style={{
            fontSize: '16px',
            color: '#666',
            textAlign: 'center'
          }}>
            No package barcodes found to print.<br/>
            Please generate some package barcodes first.
          </div>
        </div>
      );
    }
    
    return (
      <div style={{
        display: 'flex',
        flexWrap: 'wrap',
        justifyContent: 'center',
        alignItems: 'center',
        padding: '10px',
        width: '100%'
      }}>
        <div style={{
          width: '100%',
          textAlign: 'center',
          marginBottom: '20px',
          fontSize: '18px',
          fontWeight: 'bold',
          color: '#1890ff'
        }}>
          Package Barcodes - Printing {packageBarcodes.length} codes
        </div>
        {packageBarcodes.map((item, index) => (
          // Duplicate each barcode 3 times
          [1, 2, 3].map((duplicate) => (
            <div key={`${index}-${duplicate}`} style={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              margin: '10px',
              padding: '5px',
              border: 'none',
              background: 'none',
              minWidth: '160px'
            }}>
              <Barcode value={item.bar_code} width={1.5} height={40} displayValue={true}/>
              <div style={{ fontSize: '10px', marginTop: '5px', color: '#666' }}>
                {item.bar_code ? item.bar_code.substring(0, 8) + '...' : 'No Code'}
              </div>
            </div>
          ))
        )).flat()}
      </div>
    );
  }
}


class SampleBarCodeForm extends React.Component {

  state = {
    numer_of_codes:'',  
    bar_code_type:'',
    datarequested:false,
    dataLoading:true, // Loading indicator for initial data fetch
    sample_barcodes:[],
    filtered_barcodes:[], // For search functionality (All tab)
    search_term: '', // Search state
    sort_field: 'date', // Default sort field
    sort_order: 'desc', // Default sort order (newest first)
    currentPage: 1, // Pagination: current page
    pageSize: 20,   // Pagination: items per page
    show_qrModel:false,
    selected_record:{},
    selected_for_print: null, // Track which barcode is selected for printing
    active_sample_barcodes:[],
    userrights:{},

    // Tabs + server-side pagination
    currentTab: 'all',
    tabData: { all: [], active: [], single: [], batch: [], package: [] },
    totalByTab: { all: 0, active: 0, single: 0, batch: 0, package: 0 },

    // New printing options
    printQuantity: 10, // Default quantity for bulk printing
    showPrintModal: false, // Show print quantity modal
    selectedPrintType: '', // Type of codes to print in bulk
    fetchedPrintData: [], // Store fetched data for printing

  }

  componentDidMount(){
  

    if(localStorage.getItem("bizuserid")){
      bizuserid= CryptoJS.AES.decrypt(localStorage.getItem("bizuserid") , 'my-secret-key@1234').toString(CryptoJS.enc.Utf8)
   }else{
      bizuserid= ''
   }
    
    
    if(localStorage.getItem("token")){
       token= localStorage.getItem("token")
    }else{
       token= ''
    }


    axios.defaults.headers={
      "Content-Type":"application/json",
      Authorization:`Token ${token}`
    }

    // Use Promise.all to wait for all data to load before hiding loading indicator
    Promise.all([
      this.fetchBarcodes({ tab: 'all', page: 1, page_size: this.state.pageSize }),
      this.fetchBarcodes({ tab: 'active', page: 1, page_size: this.state.pageSize }),
      axios.get(serverconfig.backendserverurl+`/api/accountrights/?user=${bizuserid}`)
    ])
    .then(([allRes, activeRes, rightsRes]) => {
        const allData = allRes.results;
        const activeData = activeRes.results;
        const sortedData = this.sortData(allData, this.state.sort_field, this.state.sort_order);
        this.setState(prev => ({
          sample_barcodes: allData,
          filtered_barcodes: sortedData,
          active_sample_barcodes: activeData,
          userrights: rightsRes.data[0],
          dataLoading: false,
          tabData: { ...prev.tabData, all: allData, active: activeData },
          totalByTab: { ...prev.totalByTab, all: allRes.count, active: activeRes.count },
        }));
    })
    .catch(error => {
        console.log(error);
        this.setState({ dataLoading: false }); // Hide loading even on error
    });

  }

  // Generic server-side fetcher
  fetchBarcodes = async ({ tab, page = 1, page_size = 20, search = '' }) => {
    const params = new URLSearchParams();
    params.append('page', page);
    params.append('page_size', page_size);
    if (search) params.append('search', search);

    if (tab === 'active') params.append('status', 'active');
    if (tab === 'single') params.append('bar_code_type', 'single_entry');
    if (tab === 'batch') params.append('bar_code_type', 'batch_entry');
    if (tab === 'package') params.append('bar_code_type', 'package');

    const url = `${serverconfig.backendserverurl}/api/sample_barcodes/?${params.toString()}`;
    const res = await axios.get(url);
    const count = res.data?.count ?? (Array.isArray(res.data) ? res.data.length : 0);
    const results = res.data?.results ?? res.data ?? [];
    return { count, results };
  }

  handleTabChange = async (key) => {
    this.setState({ currentTab: key, currentPage: 1 });
    try {
      this.setState({ dataLoading: true });
      const { pageSize, search_term } = this.state;
      const { count, results } = await this.fetchBarcodes({ tab: key, page: 1, page_size: pageSize, search: search_term });
      this.setState(prev => ({
        dataLoading: false,
        tabData: { ...prev.tabData, [key]: results },
        totalByTab: { ...prev.totalByTab, [key]: count },
        // Keep filtered_barcodes/sample_barcodes in sync for All tab utilities
        ...(key === 'all' ? { sample_barcodes: results, filtered_barcodes: this.sortData(results, this.state.sort_field, this.state.sort_order) } : {}),
        ...(key === 'active' ? { active_sample_barcodes: results } : {}),
      }));
    } catch (e) {
      console.log(e);
      this.setState({ dataLoading: false });
    }
  }

  // Sorting function
  sortData = (data, field, order) => {
    const sortedData = [...data].sort((a, b) => {
      let aValue, bValue;
      
      if (field === 'date') {
        aValue = new Date(a.date);
        bValue = new Date(b.date);
      } else if (field === 'bar_code_type') {
        aValue = a.bar_code_type.toLowerCase();
        bValue = b.bar_code_type.toLowerCase();
      } else if (field === 'status') {
        aValue = a.status.toLowerCase();
        bValue = b.status.toLowerCase();
      } else {
        aValue = a[field];
        bValue = b[field];
      }
      
      if (order === 'asc') {
        return aValue > bValue ? 1 : -1;
      } else {
        return aValue < bValue ? 1 : -1;
      }
    });
    
    return sortedData;
  }

  // Handle sorting
  handleSort = (field) => {
    const newOrder = this.state.sort_field === field && this.state.sort_order === 'asc' ? 'desc' : 'asc';
    const sortedData = this.sortData(this.state.filtered_barcodes, field, newOrder);
    this.setState({
      sort_field: field,
      sort_order: newOrder,
      filtered_barcodes: sortedData,
      currentPage: 1 // Reset to first page on sort
    });
  }

  // Search functionality
  handleSearch = async (value) => {
    this.setState({ search_term: value, currentPage: 1 });
    try {
      this.setState({ dataLoading: true });
      const { pageSize, currentTab } = this.state;
      const { count, results } = await this.fetchBarcodes({ tab: currentTab, page: 1, page_size: pageSize, search: value });
      if (currentTab === 'all') {
        const sortedFilteredData = this.sortData(results, this.state.sort_field, this.state.sort_order);
        this.setState(prev => ({
          dataLoading: false,
          sample_barcodes: results,
          filtered_barcodes: sortedFilteredData,
          tabData: { ...prev.tabData, all: results },
          totalByTab: { ...prev.totalByTab, all: count },
        }));
      } else {
        this.setState(prev => ({
          dataLoading: false,
          tabData: { ...prev.tabData, [currentTab]: results },
          totalByTab: { ...prev.totalByTab, [currentTab]: count },
          ...(currentTab === 'active' ? { active_sample_barcodes: results } : {}),
        }));
      }
    } catch (e) {
      console.log(e);
      this.setState({ dataLoading: false });
    }
  }

  // Handle barcode selection for printing
  handleSelectForPrint = (item) => {
    this.setState({ 
      selected_for_print: item,
      selected_record: item 
    });
  }

  // Handle bulk printing with quantity selection
  handleBulkPrint = async (type) => {
    try {
      console.log(`Starting bulk print for type: ${type}`);
      
      // Fetch the actual data once and store it
      const availableBarcodes = await this.fetchBarcodesForPrinting(type);
      
      console.log(`Found ${availableBarcodes.length} ${type} barcodes available for printing`);
      
      if (availableBarcodes.length === 0) {
        alert(`No ACTIVE ${type.replace('_', ' ')} barcodes found to print. Please generate some active barcodes first.`);
        return;
      }
      
      this.setState({ 
        selectedPrintType: type,
        showPrintModal: true,
        printQuantity: Math.min(10, availableBarcodes.length), // Set reasonable default
        fetchedPrintData: availableBarcodes // Store the fetched data
      });
      
    } catch (error) {
      console.error('Error in handleBulkPrint:', error);
      alert('Error loading barcodes for printing. Please try again.');
    }
  }

  // Handle print quantity modal
  handlePrintQuantityChange = (value) => {
    this.setState({ printQuantity: value });
  }

  // Fetch ACTIVE barcodes directly from API for bulk printing
  fetchBarcodesForPrinting = async (type, quantity = null) => {
    try {
      console.log(`Fetching ACTIVE ${type} barcodes for printing: ${quantity}`);
      
      // Always fetch ACTIVE barcodes only
      // First get all active barcodes, then filter by type
      const { results: allActiveBarcodes } = await this.fetchBarcodes({ 
        tab: 'active', 
        page: 1, 
        page_size: quantity || 1000 
      });
      
      // Filter by the specific type
      let filteredBarcodes = [];
      if (type === 'single_entry') {
        filteredBarcodes = allActiveBarcodes.filter(barcode => barcode.bar_code_type === 'single_entry');
      } else if (type === 'batch_entry') {
        filteredBarcodes = allActiveBarcodes.filter(barcode => barcode.bar_code_type === 'batch_entry');
      } else if (type === 'package') {
        filteredBarcodes = allActiveBarcodes.filter(barcode => barcode.bar_code_type === 'package');
      } else if (type === 'active') {
        filteredBarcodes = allActiveBarcodes; // All active barcodes
      }
      
      console.log(`Fetched ${filteredBarcodes.length} ACTIVE ${type} barcodes for printing:`, filteredBarcodes);
      return filteredBarcodes;
      
    } catch (error) {
      console.error(`Error fetching ACTIVE ${type} barcodes for printing:`, error);
      return [];
    }
  }

  // Get barcodes for printing based on type (with fallback to local data)
  getBarcodesForPrinting = (type) => {
    const { tabData, active_sample_barcodes, sample_barcodes } = this.state;
    
    console.log('getBarcodesForPrinting - Debug:', {
      type: type,
      tabData: tabData,
      active_sample_barcodes: active_sample_barcodes,
      sample_barcodes: sample_barcodes
    });
    
    let result = [];
    switch(type) {
      case 'single_entry':
        // Try tabData first, fallback to filtering sample_barcodes
        result = (tabData.single && tabData.single.length > 0) 
          ? tabData.single 
          : sample_barcodes.filter(item => item.bar_code_type === 'single_entry');
        break;
      case 'batch_entry':
        // Try tabData first, fallback to filtering sample_barcodes
        result = (tabData.batch && tabData.batch.length > 0) 
          ? tabData.batch 
          : sample_barcodes.filter(item => item.bar_code_type === 'batch_entry');
        break;
      case 'package':
        // Try tabData first, fallback to filtering sample_barcodes
        result = (tabData.package && tabData.package.length > 0) 
          ? tabData.package 
          : sample_barcodes.filter(item => item.bar_code_type === 'package');
        break;
      case 'active':
        result = active_sample_barcodes || [];
        break;
      default:
        result = [];
    }
    
    console.log(`getBarcodesForPrinting - Result for ${type}:`, result);
    return result;
  }

  // Close print modal
  handleClosePrintModal = () => {
    this.setState({ 
      showPrintModal: false,
      selectedPrintType: '',
      printQuantity: 10,
      fetchedPrintData: []
    });
  }

  //submit button pressed
  handleFormSubmit=(event) =>{
    this.setState({datarequested:true})

    let form_data = new FormData();
    form_data.append('numer_of_codes', this.state.numer_of_codes);
    form_data.append('bar_code_type', this.state.bar_code_type);

      axios.post(serverconfig.backendserverurl+'/customqueries/generate_barcodes', form_data, {
        headers: {
          'content-type': 'multipart/form-data'
        }
      })
    .then(res => this.setState({datarequested:false})
,    window.location.reload(false)
    )
    .catch(error => console.log(error))

  }

  onPageChange = async (page, pageSize) => {
    this.setState({ currentPage: page, pageSize });
    try {
      this.setState({ dataLoading: true });
      const { currentTab, search_term } = this.state;
      const { count, results } = await this.fetchBarcodes({ tab: currentTab, page, page_size: pageSize, search: search_term });
      if (currentTab === 'all') {
        const sortedFilteredData = this.sortData(results, this.state.sort_field, this.state.sort_order);
        this.setState(prev => ({
          dataLoading: false,
          sample_barcodes: results,
          filtered_barcodes: sortedFilteredData,
          tabData: { ...prev.tabData, all: results },
          totalByTab: { ...prev.totalByTab, all: count },
        }));
      } else {
        this.setState(prev => ({
          dataLoading: false,
          tabData: { ...prev.tabData, [currentTab]: results },
          totalByTab: { ...prev.totalByTab, [currentTab]: count },
          ...(currentTab === 'active' ? { active_sample_barcodes: results } : {}),
        }));
      }
    } catch (e) {
      console.log(e);
      this.setState({ dataLoading: false });
    }
  }

  getSortIcon = (field) => {
    if (this.state.sort_field !== field) {
      return <SortAscendingOutlined style={{ color: '#ccc' }} />;
    }
    return this.state.sort_order === 'asc' ? 
      <SortAscendingOutlined style={{ color: '#1890ff' }} /> : 
      <SortDescendingOutlined style={{ color: '#1890ff' }} />;
  }


  render(){

    if(this.state.dataLoading===true){
      return(
        <div style={{display: 'flex',  justifyContent:'center', alignItems:'center', height: '400px' }}>
          <Spin size="large" indicator={antIcon}>
            <div className="content">
              <h3>Loading Barcode Data...</h3>
            </div>
          </Spin>
        </div>
      )
    }

    if(this.state.datarequested===true){
      return(
        <div style={{display: 'flex',  justifyContent:'center', alignItems:'center' }}>
        <Spin indicator={antIcon} />
        </div>
      )

    }else{
      // Server-side pagination: render the current page data as-is
      const { currentPage, pageSize, filtered_barcodes } = this.state;
      const paginatedBarcodes = filtered_barcodes;

      return (
        <div style={{ padding: '20px',overflowX:'auto' }}>

          {/* Hidden print components */}
          <div style={{display: "none"}}>
            <SingleEntryPrintComponent
              title={"Single Entry Barcodes"} 
              sample_barcodes={this.getBarcodesForPrinting('single_entry')}
              ref={el => (this.singleEntryComponentRef = el)} 
            />
          </div>

          <div style={{display: "none"}}>
            <BatchEntryPrintComponent
              title={"Batch Entry Barcodes"} 
              sample_barcodes={this.getBarcodesForPrinting('batch_entry')}
              ref={el => (this.batchEntryComponentRef = el)} 
            />
          </div>

          <div style={{display: "none"}}>
            <PackagePrintComponent
              title={"Package Barcodes"} 
              sample_barcodes={this.getBarcodesForPrinting('package')}
              ref={el => (this.packageComponentRef = el)} 
            />
          </div>

          <div style={{display: "none"}}>
            <SinglePrintComponent
              barcode_value={this.state.selected_for_print?.bar_code || ''}
              barcode_type={this.state.selected_for_print?.bar_code_type || ''}
              status={this.state.selected_for_print?.status || ''}
              ref={el => (this.singleComponentRef = el)} 
            />
          </div>

          <div style={{display: "none"}}>
            <QuantityPrintComponent
              barcodes={this.state.fetchedPrintData}
              quantity={this.state.printQuantity}
              type={this.state.selectedPrintType}
              ref={el => (this.quantityComponentRef = el)} 
            />
          </div>

          <div style={{display: "none"}}>
            <DynamicPrintComponent
              type={this.state.selectedPrintType}
              quantity={this.state.printQuantity}
              fetchFunction={this.fetchBarcodesForPrinting}
              ref={el => (this.dynamicComponentRef = el)} 
            />
          </div>

          {/* Header with print buttons */}
          <div style={{ 
            display: 'flex', 
            justifyContent: 'space-between', 
            alignItems: 'center', 
            marginBottom: '20px',
            padding: '15px',
            background: '#f5f5f5',
            borderRadius: '8px',
            overflowX:'auto'
          }}>
            <h2 style={{ margin: 0, color: '#1890ff' }}>Barcode Management</h2>
            
            <Space wrap>
              {/* Bulk Print Buttons */}
              <Dropdown.Button
                overlay={
                  <Menu>
                    <Menu.Item key="single_all" onClick={() => this.handleBulkPrint('single_entry')}>
                      Print Single Entry (All)
                    </Menu.Item>
                    <Menu.Item key="batch_all" onClick={() => this.handleBulkPrint('batch_entry')}>
                      Print Batch Entry (All)
                    </Menu.Item>
                    <Menu.Item key="package_all" onClick={() => this.handleBulkPrint('package')}>
                      Print Package (All)
                    </Menu.Item>
                    <Menu.Divider />
                    <Menu.Item key="single_qty" onClick={() => this.handleBulkPrint('single_entry')}>
                      Print Single Entry (Quantity)
                    </Menu.Item>
                    <Menu.Item key="batch_qty" onClick={() => this.handleBulkPrint('batch_entry')}>
                      Print Batch Entry (Quantity)
                    </Menu.Item>
                    <Menu.Item key="package_qty" onClick={() => this.handleBulkPrint('package')}>
                      Print Package (Quantity)
                    </Menu.Item>
                  </Menu>
                }
                type="primary"
                icon={<PrinterOutlined />}
                style={{ background: '#52c41a', borderColor: '#52c41a' }}
              >
                Bulk Print
              </Dropdown.Button>

              {/* Individual Print Button */}
              <ReactToPrint
                trigger={() => 
                <Button 
                  type={this.state.selected_for_print ? "primary" : "default"} 
                  shape="round" 
                  icon={<PrinterOutlined />}
                  disabled={!this.state.selected_for_print}
                >
                  {this.state.selected_for_print ? 
                    `Print Selected (${this.state.selected_for_print.bar_code.substring(0, 8)}...)` : 
                    'Select Barcode to Print'
                  }
                </Button>
                }
                content={() => this.singleComponentRef}
                documentTitle={this.state.selected_for_print ? 
                  `Umoja_Barcode_${this.state.selected_for_print.bar_code}_${this.state.selected_for_print.bar_code_type}_${new Date().toISOString().split('T')[0]}` : 
                  'Umoja_Barcode_NotSelected'
                }
                onBeforePrint={() => {
                  if (!this.state.selected_for_print) {
                    alert('Please select a barcode first by clicking "Select for Print" on any row');
                    return false;
                  }
                  console.log(`Preparing barcode ${this.state.selected_for_print.bar_code} for print...`);
                }}
                onAfterPrint={() => {
                  if (this.state.selected_for_print) {
                    console.log(`Barcode ${this.state.selected_for_print.bar_code} printed successfully`);
                  }
                }}
              />
            </Space>
          </div>

          {/* Selection status banner */}
          {this.state.selected_for_print && (
            <div style={{ 
              background: '#e6f7ff', 
              border: '1px solid #1890ff', 
              padding: '12px', 
              borderRadius: '6px', 
              marginBottom: '20px',
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center'
            }}>
              <div>
                <strong>Selected for printing:</strong> {this.state.selected_for_print.bar_code} 
                <span style={{ marginLeft: '10px', color: '#666' }}>
                  ({this.state.selected_for_print.bar_code_type} | {this.state.selected_for_print.status})
                </span>
              </div>
              <Button 
                size="small" 
                onClick={() => this.setState({ selected_for_print: null })}
              >
                Clear Selection
              </Button>
            </div>
          )}

          {/* Search and Sort functionality */}
          <div style={{ marginBottom: '20px' }}>
            <div style={{ display: 'flex', gap: '15px', alignItems: 'center', marginBottom: '15px' }}>
              <Search
                placeholder="Search barcodes by code, type, status, or date..."
                allowClear
                enterButton={<SearchOutlined />}
                size="large"
                value={this.state.search_term}
                onChange={(e) => this.handleSearch(e.target.value)}
                onSearch={this.handleSearch}
                style={{ maxWidth: '400px' }}
              />
              
              <div style={{ display: 'flex', gap: '10px' }}>
                <Button 
                  onClick={() => this.handleSort('date')}
                  icon={this.getSortIcon('date')}
                  type={this.state.sort_field === 'date' ? 'primary' : 'default'}
                >
                  Sort by Date
                </Button>
                <Button 
                  onClick={() => this.handleSort('bar_code_type')}
                  icon={this.getSortIcon('bar_code_type')}
                  type={this.state.sort_field === 'bar_code_type' ? 'primary' : 'default'}
                >
                  Sort by Type
                </Button>
                <Button 
                  onClick={() => this.handleSort('status')}
                  icon={this.getSortIcon('status')}
                  type={this.state.sort_field === 'status' ? 'primary' : 'default'}
                >
                  Sort by Status
                </Button>
              </div>
            </div>
            
            <div style={{ color: '#666' }}>
              Showing {this.state.filtered_barcodes.length} of {this.state.sample_barcodes.length} barcodes
              {this.state.sort_field && (
                <span style={{ marginLeft: '10px' }}>
                  | Sorted by {this.state.sort_field} ({this.state.sort_order === 'asc' ? 'ascending' : 'descending'})
                </span>
              )}
            </div>
          </div>

          {/* Barcodes tabs */}
          <Tabs activeKey={this.state.currentTab} onChange={this.handleTabChange}>
            <Tabs.TabPane tab="All" key="all">
              <Card title="All Barcodes" bordered={false}>
            <reactstrp.Table bordered responsive>
              <thead>
                <tr>
                  <th style={{ cursor: 'pointer' }} onClick={() => this.handleSort('date')}>
                    Date {this.getSortIcon('date')}
                  </th>
                  <th style={{ cursor: 'pointer' }} onClick={() => this.handleSort('bar_code_type')}>
                    Barcode Type {this.getSortIcon('bar_code_type')}
                  </th>
                  <th>Code</th>
                  <th style={{ cursor: 'pointer' }} onClick={() => this.handleSort('status')}>
                    Status {this.getSortIcon('status')}
                  </th>
                  <th>Repackaged</th>
                  <th>Reason for Repackage</th>
                  <th>Actions</th>
                </tr>
              </thead>
              <tbody>
              {paginatedBarcodes.map(
                (itm, index)=>(
                  <tr 
                    key={`${itm.bar_code || 'row'}-${index}`}
                    style={{
                      backgroundColor: this.state.selected_for_print?.bar_code === itm.bar_code ? '#e6f7ff' : 'transparent'
                    }}
                  >
                    <td>{itm.date}</td>
                    <td>
                      <span style={{
                        background: itm.bar_code_type === 'batch_entry' ? '#e6f7ff' : '#f6ffed',
                        color: itm.bar_code_type === 'batch_entry' ? '#1890ff' : '#52c41a',
                        padding: '4px 8px',
                        borderRadius: '4px',
                        fontSize: '12px'
                      }}>
                        {itm.bar_code_type}
                      </span>
                    </td>
                    <td style={{ fontFamily: 'monospace', fontWeight: 'bold' }}>{itm.bar_code}</td>
                    <td>
                      <span style={{
                        color: itm.status === "used" ? '#52c41a' : '#fa8c16',
                        fontWeight: 'bold'
                      }}>
                        {itm.status}
                      </span>
                    </td>
                    <td>{itm.repackaged ? 'Yes' : 'No'}</td>
                    <td>{itm.reason_for_repackage || '-'}</td>
                    <td>
                      <Space>
                        <Button 
                          type="link" 
                          onClick={()=>{
                            this.setState({show_qrModel:true})
                            this.setState({selected_record:itm})
                          }}
                        >
                          View Details
                        </Button>
                        <Button 
                          type={this.state.selected_for_print?.bar_code === itm.bar_code ? "primary" : "default"}
                          size="small"
                          onClick={() => this.handleSelectForPrint(itm)}
                        >
                          {this.state.selected_for_print?.bar_code === itm.bar_code ? "Selected ✓" : "Select for Print"}
                        </Button>
                      </Space>
                    </td>
                  </tr>
                ))}
              </tbody>
              </reactstrp.Table>
              {/* Pagination controls */}
              <div style={{ display: 'flex', justifyContent: 'center', margin: '20px 0' }}>
                <Pagination
                  current={currentPage}
                  pageSize={pageSize}
                  total={this.state.totalByTab.all || filtered_barcodes.length}
                  showSizeChanger
                  pageSizeOptions={['10', '20', '50', '100']}
                  onChange={(page, size)=>{ this.onPageChange(page, size); }}
                  onShowSizeChange={(page, size)=>{ this.onPageChange(page, size); }}
                />
              </div>
              
              {this.state.filtered_barcodes.length === 0 && this.state.search_term && (
                <div style={{ textAlign: 'center', padding: '50px', color: '#666' }}>
                  <SearchOutlined style={{ fontSize: '48px', marginBottom: '16px' }} />
                  <h3>No barcodes found</h3>
                  <p>Try adjusting your search terms</p>
                </div>
              )}
            </Card>
            </Tabs.TabPane>

            <Tabs.TabPane tab="Active" key="active">
              <Card title="Active Barcodes" bordered={false}>
                <reactstrp.Table bordered responsive>
                  <thead>
                    <tr>
                      <th>Date</th>
                      <th>Barcode Type</th>
                      <th>Code</th>
                      <th>Status</th>
                      <th>Repackaged</th>
                      <th>Reason for Repackage</th>
                      <th>Actions</th>
                    </tr>
                  </thead>
                  <tbody>
                  {(this.state.tabData.active.length ? this.state.tabData.active : this.state.active_sample_barcodes).map((itm, index) => (
                    <tr key={`active-${index}`}>
                      <td>{itm.date}</td>
                      <td>{itm.bar_code_type}</td>
                      <td style={{ fontFamily: 'monospace', fontWeight: 'bold' }}>{itm.bar_code}</td>
                      <td>{itm.status}</td>
                      <td>{itm.repackaged ? 'Yes' : 'No'}</td>
                      <td>{itm.reason_for_repackage || '-'}</td>
                      <td>
                        <Button 
                          type="link" 
                          onClick={() => {
                            this.setState({show_qrModel:true, selected_record:itm});
                          }}
                        >
                          View Details
                        </Button>
                      </td>
                    </tr>
                  ))}
                  </tbody>
                </reactstrp.Table>
                {/* Pagination for Active */}
                <div style={{ display: 'flex', justifyContent: 'center', margin: '20px 0' }}>
                  <Pagination
                    current={currentPage}
                    pageSize={pageSize}
                    total={this.state.totalByTab.active || (this.state.tabData.active.length || this.state.active_sample_barcodes.length)}
                    showSizeChanger
                    pageSizeOptions={['10', '20', '50', '100']}
                    onChange={this.onPageChange}
                    onShowSizeChange={this.onPageChange}
                  />
                </div>
              </Card>
            </Tabs.TabPane>

            <Tabs.TabPane tab="Single Entry" key="single">
              <Card title="Single Entry Barcodes" bordered={false}>
                <reactstrp.Table bordered responsive>
                  <thead>
                    <tr>
                      <th>Date</th>
                      <th>Code</th>
                      <th>Status</th>
                    </tr>
                  </thead>
                  <tbody>
                  {(this.state.tabData.single || []).map((itm, index)=>(
                    <tr key={`single-${index}`}>
                      <td>{itm.date}</td>
                      <td style={{ fontFamily: 'monospace', fontWeight: 'bold' }}>{itm.bar_code}</td>
                      <td>{itm.status}</td>
                    </tr>
                  ))}
                  </tbody>
                </reactstrp.Table>
                {/* Pagination for Single */}
                <div style={{ display: 'flex', justifyContent: 'center', margin: '20px 0' }}>
                  <Pagination
                    current={currentPage}
                    pageSize={pageSize}
                    total={this.state.totalByTab.single || (this.state.tabData.single?.length || 0)}
                    showSizeChanger
                    pageSizeOptions={['10', '20', '50', '100']}
                    onChange={this.onPageChange}
                    onShowSizeChange={this.onPageChange}
                  />
                </div>
              </Card>
            </Tabs.TabPane>

            <Tabs.TabPane tab="Batch Entry" key="batch">
              <Card title="Batch Entry Barcodes" bordered={false}>
                <reactstrp.Table bordered responsive>
                  <thead>
                    <tr>
                      <th>Date</th>
                      <th>Code</th>
                      <th>Status</th>
                    </tr>
                  </thead>
                  <tbody>
                  {(this.state.tabData.batch || []).map((itm, index)=>(
                    <tr key={`batch-${index}`}>
                      <td>{itm.date}</td>
                      <td style={{ fontFamily: 'monospace', fontWeight: 'bold' }}>{itm.bar_code}</td>
                      <td>{itm.status}</td>
                    </tr>
                  ))}
                  </tbody>
                </reactstrp.Table>
                {/* Pagination for Batch */}
                <div style={{ display: 'flex', justifyContent: 'center', margin: '20px 0' }}>
                  <Pagination
                    current={currentPage}
                    pageSize={pageSize}
                    total={this.state.totalByTab.batch || (this.state.tabData.batch?.length || 0)}
                    showSizeChanger
                    pageSizeOptions={['10', '20', '50', '100']}
                    onChange={this.onPageChange}
                    onShowSizeChange={this.onPageChange}
                  />
                </div>
              </Card>
            </Tabs.TabPane>

            <Tabs.TabPane tab="Packages" key="package">
              <Card title="Package Barcodes" bordered={false}>
                <reactstrp.Table bordered responsive>
                  <thead>
                    <tr>
                      <th>Date</th>
                      <th>Code</th>
                      <th>Status</th>
                    </tr>
                  </thead>
                  <tbody>
                  {(this.state.tabData.package || []).map((itm, index)=>(
                    <tr key={`package-${index}`}>
                      <td>{itm.date}</td>
                      <td style={{ fontFamily: 'monospace', fontWeight: 'bold' }}>{itm.bar_code}</td>
                      <td>{itm.status}</td>
                    </tr>
                  ))}
                  </tbody>
                </reactstrp.Table>
                {/* Pagination for Package */}
                <div style={{ display: 'flex', justifyContent: 'center', margin: '20px 0' }}>
                  <Pagination
                    current={currentPage}
                    pageSize={pageSize}
                    total={this.state.totalByTab.package || (this.state.tabData.package?.length || 0)}
                    showSizeChanger
                    pageSizeOptions={['10', '20', '50', '100']}
                    onChange={this.onPageChange}
                    onShowSizeChange={this.onPageChange}
                  />
                </div>
              </Card>
            </Tabs.TabPane>
          </Tabs>

          {/* Generate new codes form */}
          <Card title="Generate New Codes" style={{ marginTop: '20px' }} bordered={false}>
            {
              this.state.userrights.create_barcodes === true?
              <Form
                onFinish={(event) => this.handleFormSubmit(event)}
                layout="vertical"
              >

                <FormItem label="Barcode type"
                    name="bar_code_type"
                    rules={[
                      {
                        required: true,
                        message: 'Please select barcode type',
                      },
                    ]}  
                >
                    <Select 
                      placeholder="Select barcode type" 
                      value={this.state.bar_code_type} 
                      onChange={(val)=>{this.setState({bar_code_type:val})}} 
                      showSearch
                      optionFilterProp="children"
                      size="large"
                    >
                      <Option value="single_entry">Single Entry</Option>
                      <Option value="batch_entry">Batch Entry</Option>
                      <Option value="package">Package</Option>
                    </Select>
                </FormItem>


                <FormItem label="Number of codes"
                  name="numer_of_codes"
                  rules={[
                    {
                      required: true,
                      message: 'Please input number of codes',
                    },
                  ]}
                >
                  <Input 
                    name="numer_of_codes"
                    placeholder="Enter number of codes to generate" 
                    value={this.state.numer_of_codes} 
                    onChange={(e) => this.setState({ numer_of_codes: e.target.value})} 
                    type='number'
                    size="large"
                    min="1"
                    max="100"
                  />
                </FormItem>


                <FormItem>
                  <Button type="primary" htmlType="submit" size="large">
                    Generate Codes
                  </Button>
                </FormItem>

              </Form>
              :
              <div style={{ textAlign: 'center', padding: '50px', color: '#666' }}>
                <p>You don't have permission to create barcodes.</p>
                <p>Please contact your administrator.</p>
              </div>
            }
          </Card>

          {/* Modal for individual barcode view */}
          {
              this.state.show_qrModel?
              <Modal              
              visible={this.state.show_qrModel}
              title="Barcode Details"
              width={800}
              onCancel={()=>{this.setState({show_qrModel:false})}}
              footer={[
                <Button key="back" onClick={()=>{this.setState({show_qrModel:false})}}>
                  Close
                </Button>
              ]}
              >
                <BarCodeView 
                  selected_record={this.state.selected_record}
                  title={"SAMPLE BARCODE"}
                  />
          
              </Modal>
              :
              null
            }

          {/* Print Quantity Selection Modal */}
          <Modal
            title={`Print ${this.state.selectedPrintType.replace('_', ' ')} Barcodes`}
            visible={this.state.showPrintModal}
            onCancel={this.handleClosePrintModal}
            footer={[
              <Button key="cancel" onClick={this.handleClosePrintModal}>
                Cancel
              </Button>,
              <ReactToPrint
                key="print"
                trigger={() => 
                  <Button type="primary" icon={<PrinterOutlined />}>
                    Print {this.state.printQuantity} Codes
                  </Button>
                }
                content={() => this.quantityComponentRef}
                documentTitle={`Umoja_${this.state.selectedPrintType}_Barcodes_${this.state.printQuantity}_${new Date().toISOString().split('T')[0]}`}
                onBeforePrint={() => {
                  console.log(`Preparing ${this.state.printQuantity} ${this.state.selectedPrintType} barcodes for print...`);
                }}
                onAfterPrint={() => {
                  console.log(`${this.state.printQuantity} ${this.state.selectedPrintType} barcodes printed successfully`);
                  this.handleClosePrintModal();
                }}
              />
            ]}
          >
            <div style={{ padding: '20px 0' }}>
              <p><strong>Barcode Type:</strong> {this.state.selectedPrintType.replace('_', ' ')}</p>
              <p><strong>Available ACTIVE Codes:</strong> {this.state.fetchedPrintData.length} codes</p>
              <p><strong>Quantity to Print:</strong> {this.state.printQuantity} codes</p>
              
              <Form.Item label="Number of ACTIVE codes to print" style={{ marginTop: '20px' }}>
                <Input
                  type="number"
                  min="1"
                  max={this.state.fetchedPrintData.length}
                  value={this.state.printQuantity}
                  onChange={(e) => this.handlePrintQuantityChange(parseInt(e.target.value) || 1)}
                  style={{ width: '200px' }}
                />
              </Form.Item>
              
              <div style={{ 
                background: '#f6ffed', 
                border: '1px solid #b7eb8f', 
                padding: '10px', 
                borderRadius: '6px',
                marginTop: '15px'
              }}>
                <p style={{ margin: 0, color: '#389e0d' }}>
                  <strong>✓ Only ACTIVE barcodes:</strong> Only active (unused) barcodes will be printed. Each barcode will be printed 3 times for easy handling.
                </p>
              </div>
            </div>
          </Modal>


        </div>
      );

    }
    
  }

}


export default SampleBarCodeForm;



